import { ArrowLeft } from "lucide-react";
import TM from "@/components/TM";
import { TRY_ROLES } from "@/components/try/TryRoleSelect";

export default function TryDemoLayout({ role, mode, onBack, onExit, children }) {
  const roleLabel = TRY_ROLES.find((r) => r.id === role)?.label || "Visitor";
  const isStudent = role === "student";

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--learner-bg)" }} data-testid="try-demo-layout">
      <div className="flex items-center justify-between px-5 py-3 bg-white border-b border-slate-200">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            data-testid="try-demo-back-btn"
            className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
          <span className="text-sm text-slate-300">|</span>
          <img
            src="/mitraa-logo-transparent.webp"
            alt="Mitraa"
            className="w-7 h-7 object-contain"
            data-testid="try-demo-logo"
          />
          <span className="font-display font-semibold text-slate-800">Try Mitraa<TM /></span>
          <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-sky-100 text-sky-700" data-testid="try-demo-role-badge">
            {roleLabel} · {mode === "guided" ? "Guided Demo" : "Free Explore"}
          </span>
        </div>
        <button
          onClick={onExit}
          data-testid="try-demo-exit-btn"
          className="text-sm font-medium text-slate-500 hover:text-slate-700 transition-colors"
        >
          Exit demo
        </button>
      </div>

      <div className={`flex-1 flex ${isStudent ? "justify-center" : "flex-col lg:flex-row"} gap-4 p-4`}>
        <div
          className={`bg-white rounded-3xl mit-shadow p-6 flex-1 ${isStudent ? "w-full max-w-3xl" : ""}`}
          data-testid="try-left-panel"
        >
          {children?.left}
        </div>

        {!isStudent && (
          <div
            className="teacher-scope font-teacher rounded-3xl w-full lg:w-[420px] shrink-0 flex flex-col overflow-hidden max-h-[calc(100vh-7rem)]"
            style={{ background: "var(--teacher-surface)", border: "1px solid var(--border-soft)" }}
            data-testid="try-right-panel"
          >
            <h3
              className="font-semibold text-base p-6 pb-4 shrink-0"
              style={{ color: "var(--teacher-text)" }}
              data-testid="try-right-panel-header"
            >
              What your teachers see — live
            </h3>
            <div
              data-testid="try-right-panel-content"
              className="text-sm px-6 pb-6 flex-1 overflow-y-auto"
              style={{ color: "var(--teacher-muted)" }}
            >
              {children?.right}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
